// extracted by mini-css-extract-plugin
export default {"page":"i2-z","cartModal":"j2-z","checkout":"k2-z","placeholder":"l2-z","account":"m2-z"};